import React from "react";
import PropTypes from "prop-types";
import "./item.css";
import Button from "@material-ui/core/Button";

import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";

import * as handler from "../Actions/main";
import { connect } from "react-redux";
function ConfirmationDialogRaw(props) {
  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = React.useState(valueProp);

  React.useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  function handleCancel() {
    onClose();
  }

  function handleOk() {
    onClose(value);
    props.clear();
    props.back();
  }

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      {...other}
    >
      <DialogTitle id="confirmation-dialog-title">
        This will remove all items from your cart .Are you sure to change
        station ?
      </DialogTitle>

      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          NO
        </Button>
        <Button onClick={handleOk} color="primary">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationDialogRaw.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired
};

function ChangeLocation(props) {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState("Dione");

  function handleClickListItem() {
    setOpen(true);
  }

  function handleClose(newValue) {
    setOpen(false);

    if (newValue) {
      setValue(newValue);
    }
  }

  return (
    <div>
      {/* <Button
        
        style={{ color: "#3D83E1", paddingRight: 0 }}
        onClick={handleClickListItem}
        size="small"
        id="sc4"
      >
        Clear Cart{" "}
      </Button> */}

      {/* <IconButton
        edge="start"
        style={{ color: "white", paddingTop: "5px" }}
        onClick={handleClickListItem}
        aria-label="Close"
      >
     
      </IconButton> */}

      <Button
        style={{ color: "#3D83E1", paddingRight: 0 }}
        onClick={handleClickListItem}
        size="small"
        className="sc2"
      >
        Change Location{" "}
      </Button>

      <ConfirmationDialogRaw
        back={props.back}
        clear={props.clear}
        keepMounted
        open={open}
        onClose={handleClose}
        value={value}
      />
    </div>
  );
}
const mapDispatchToProps = dispatch => {
  return {
    clear: () => dispatch(handler.clearCart())
  };
};
export default connect(
  null,
  mapDispatchToProps
)(ChangeLocation);
